module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch3_20210921025649_T.fea0eeb2.jpg";